module.exports = __webpack_public_path__ + "img/icon5.3aee8ec9.png";